import ProductBrand from '@/components/feature/ProductBrand';
import { APP_NAME, SUPPORT_CONTACT } from '@/lib/brand';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#f8f7f4] px-4 py-10">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl p-8">
        <ProductBrand compact />
        <h1 className="text-xl font-bold text-[#1a2332] mb-4">Chính Sách Quyền Riêng Tư</h1>
        <div className="text-sm text-gray-600 space-y-3 leading-relaxed">
          <p>
            {APP_NAME} là ứng dụng quản lý tiệm cầm đồ. Chúng tôi thu thập và lưu trữ thông tin
            cần thiết để vận hành dịch vụ cho cửa hàng của bạn.
          </p>
          <p className="font-semibold text-[#1a2332]">Thông tin thu thập</p>
          <p>
            Tài khoản đăng nhập (email, tên hiển thị), thông tin cửa hàng (tên, địa chỉ, số điện
            thoại, logo), và dữ liệu nghiệp vụ do bạn nhập (khách hàng, hợp đồng cầm đồ, tài sản,
            doanh thu). Khi đăng nhập bằng Google, chúng tôi chỉ nhận tên, ảnh đại diện và địa chỉ
            email của bạn.
          </p>
          <p className="font-semibold text-[#1a2332]">Cách sử dụng</p>
          <p>
            Dữ liệu chỉ dùng để cung cấp tính năng của ứng dụng. Mỗi cửa hàng chỉ truy cập được dữ
            liệu của chính mình. Chúng tôi không bán, không chia sẻ dữ liệu của bạn cho bên thứ ba
            vì mục đích quảng cáo.
          </p>
          <p className="font-semibold text-[#1a2332]">Lưu trữ và bảo mật</p>
          <p>
            Dữ liệu lưu trên hạ tầng Supabase với mã hoá truyền tải và phân quyền truy cập theo cửa
            hàng. Bạn có thể yêu cầu xoá tài khoản và toàn bộ dữ liệu bất cứ lúc nào.
          </p>
          <p className="font-semibold text-[#1a2332]">Liên hệ</p>
          <p>
            {SUPPORT_CONTACT
              ? `Mọi thắc mắc về quyền riêng tư, liên hệ: ${SUPPORT_CONTACT}.`
              : 'Mọi thắc mắc về quyền riêng tư, vui lòng liên hệ quản trị viên.'}
          </p>
        </div>
        <a href="/login" className="inline-block mt-6 text-sm text-[#f59e0b] hover:text-[#d97706] font-medium">
          ← Quay lại đăng nhập
        </a>
      </div>
    </div>
  );
}
